import { Skeleton } from '@/components/ui/skeleton';

const SKELETON_ITEM_COUNT = 3;

export const VendorRequestsSidenavSkeleton = () => (
  <nav className="space-y-0.5 lg:sticky lg:top-0">
    <ul className="grid grid-cols-3 gap-1 lg:block">
      {Array.from({ length: SKELETON_ITEM_COUNT }).map((_, index) => (
        <li key={index} className="relative">
          <div data-testid="sidenav-item-skeleton" className="flex items-center justify-between w-full h-9 px-4 py-2">
            <Skeleton className="h-4 w-16" />
            <Skeleton className="h-4 w-6 rounded-full" />
          </div>
        </li>
      ))}
    </ul>
  </nav>
);
